module.exports = __webpack_public_path__ + "static/media/calender-class.6ee405e4.svg";